var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass:
        "focus:ring-4 focus:outline-none text-low rounded-full text-center inline-flex items-center mr-2 mb-2",
      class: [_vm.isOutlined ? "outlined-button" : "filled-button"],
      attrs: { type: "button" },
      on: { click: _vm.click },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }